<template>
  <div class="guide-page">
    <div class="guide-header">
      <div class="brand-row">
        <span class="brand-mark">签</span>
        <span class="brand-name">自由职业者签约</span>
      </div>
      <div class="header-deco" aria-hidden="true">
        <span class="deco-seal">Sign</span>
      </div>
    </div>

    <div class="guide-card">
      <div class="guide-title">你收到1个任务，共1个文件待签署</div>
      <div class="deadline">
        截止时间：请在3天内完成文件签署，过期将无法继续签署
      </div>

      <button class="wx-btn" type="button" @click="openWechat">
        <svg class="wx-icon" viewBox="0 0 24 24" aria-hidden="true">
          <path
            fill="currentColor"
            d="M9.5 4C5.91 4 3 6.46 3 9.5c0 1.76.96 3.33 2.47 4.37L5 16.5l2.55-1.28c.6.12 1.22.18 1.85.18.2 0 .4 0 .6-.02C9.35 14.5 9 13.55 9 12.5 9 8.91 12.13 6 16 6c.14 0 .28 0 .42.01C15.3 4.78 12.62 4 9.5 4zm6.5 3C12.91 7 10 9.24 10 12c0 2.76 2.91 5 6.5 5 .5 0 1-.05 1.47-.14L20.5 18l-.72-1.9C21.2 15.2 22 13.68 22 12c0-2.76-2.91-5-6-5zm-8.25 1.75a1 1 0 110 2 1 1 0 010-2zm4.5 0a1 1 0 110 2 1 1 0 010-2zM14.5 10.5a.9.9 0 110 1.8.9.9 0 010-1.8zm4 0a.9.9 0 110 1.8.9.9 0 010-1.8z"
          />
        </svg>
        打开微信签署
      </button>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";

export default {
  name: "Guide",
  methods: {
    getSignUrl() {
      const content = this.$route.query.content || "";
      const query = content ? "?content=" + encodeURIComponent(content) : "";
      return window.location.origin + "/mine/userInfo" + query;
    },
    copyText(text) {
      try {
        const input = document.createElement("textarea");
        input.value = text;
        input.setAttribute("readonly", "readonly");
        input.style.cssText = "position:fixed;top:0;left:0;opacity:0;";
        document.body.appendChild(input);
        input.focus();
        input.select();
        input.setSelectionRange(0, text.length);
        const ok = document.execCommand("copy");
        document.body.removeChild(input);
        if (ok) return true;
      } catch (e) {
        // 继续走 clipboard API
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text);
        return true;
      }
      return false;
    },
    launchWechat(signUrl) {
      const ua = navigator.userAgent;
      if (/android/i.test(ua)) {
        const url = new URL(signUrl);
        window.location.href =
          "intent://" +
          url.host +
          url.pathname +
          url.search +
          "#Intent;scheme=https;package=com.tencent.mm;end";
        return;
      }
      window.location.href = "weixin://";
    },
    openWechat() {
      const signUrl = this.getSignUrl();
      const copied = this.copyText(signUrl);
      Toast(copied ? "链接已复制，正在打开微信" : "正在打开微信");
      this.launchWechat(signUrl);
    },
  },
};
</script>

<style scoped>
.guide-page {
  min-height: 100vh;
  background: #f7f8fa;
  padding-bottom: 40px;
}
.guide-header {
  position: relative;
  height: 180px;
  padding: 28px 24px 0;
  background: linear-gradient(180deg, #fff5f4 0%, #ffe8e6 55%, #f7f8fa 100%);
  overflow: hidden;
}
.brand-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.brand-mark {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: #ee0a24;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}
.brand-name {
  font-size: 20px;
  font-weight: 700;
  color: #ee0a24;
  letter-spacing: 0.5px;
}
.header-deco {
  position: absolute;
  right: 18px;
  top: 36px;
  width: 88px;
  height: 88px;
  border-radius: 50%;
  border: 3px solid rgba(238, 10, 36, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotate(12deg);
}
.deco-seal {
  font-size: 18px;
  font-weight: 700;
  color: rgba(238, 10, 36, 0.35);
}
.guide-card {
  margin: -56px 16px 0;
  background: #fff;
  border-radius: 16px;
  padding: 24px 20px 28px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  position: relative;
  z-index: 1;
}
.guide-title {
  font-size: 18px;
  font-weight: 600;
  color: #323233;
  line-height: 1.5;
  margin-bottom: 16px;
}
.deadline {
  font-size: 14px;
  color: #646566;
  line-height: 1.7;
  margin-bottom: 28px;
}
.wx-btn {
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 24px;
  background: #07c160;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.wx-btn:active {
  opacity: 0.88;
}
.wx-icon {
  width: 22px;
  height: 22px;
}
</style>
